<ul
  [hidden]="!isOpen"
  class="form-autocomplete-list"
  [ngClass]="listClass"
  role="listbox"
  [attr.aria-labelledby]="triggerId"
>
  <app-form-autocomplete-item
    *ngFor="let suggestion of suggestions"
    [suggestion]="suggestion"
    (click)="setSelectedSuggestion(suggestion)"
    (keydown.enter)="setSelectedSuggestion(suggestion)"
    (keydown.space)="setSelectedSuggestion(suggestion)"
  ></app-form-autocomplete-item>
</ul>
